<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Rapports</h1>
      <!-- <button
        class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        @click="toPrint"
      >
        <i class="fas fa-download fa-sm text-white-50"></i>
        Imprimer le Rapport
      </button> -->
    </div>
    <nav
      class="navbar navbar-expand navbar-light bg-white mb-4 static-top shadow"
    >
      <form
        @submit.prevent="filterBy"
        v-if="userPermissions.some((e) => [P_REPORT_MASTER].includes(e))"
        style="width: 100%"
      >
        <p class="text-primary" v-if="!display_pannel">
          <button
            class="btn btn-outline-primary"
            title="Panneau des filtres"
            type="button"
            @click="handleDisplayPannel"
          >
            <i class="fas fa-expand-arrows-alt"></i> Panneau des filtres
          </button>
        </p>
        <p class="text-primary" v-if="display_pannel">
          <button
            class="btn btn-outline-primary"
            title="Fermer le panneau"
            type="button"
            @click="handleDisplayPannel"
          >
            <i class="fas fa-times"></i> Fermer le panneau
          </button>
        </p>

        <!-- <fieldset><legend>Filtrage par date de demande</legend></fieldset> -->
        <transition name="slide-fade">
          <div v-if="display_pannel">
            <p class="mb-2">Filtrage par date de demande</p>
            <div class="row mb-2">
              <div class="col-md-3">
                <div class="form-row">
                  <label for="demand_start_date" class="col-4 text-right"
                    >Début:</label
                  >
                  <VueCtkDateTimePicker
                    name="demand_start_date"
                    class="ml-0 mr-0 pl-0 pr-0 col-8"
                    v-model="demand_start_date"
                    label="date début"
                    color="#0a3764"
                    button-color="#0a3764"
                    locale="fr"
                    input-size="sm"
                    format="YYYY-MM-DD HH:mm"
                    button-now-translation="Aujourd'hui"
                    id="demand_start_date"
                    :error="submitted && !demand_start_date ? true : false"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-row">
                  <label for="demand_end_date" class="col-4 text-right"
                    >Fin:</label
                  >
                  <VueCtkDateTimePicker
                    name="demand_end_date"
                    class="ml-0 mr-0 pl-0 pr-0 col-8"
                    v-model="demand_end_date"
                    label="date fin"
                    color="#0a3764"
                    button-color="#0a3764"
                    locale="fr"
                    input-size="sm"
                    format="YYYY-MM-DD HH:mm"
                    button-now-translation="Aujourd'hui"
                    id="demand_end_date"
                    :error="submitted && !demand_end_date ? true : false"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-row">
                  <label for="statut" class="col-4 text-right">Statut:</label>
                  <select
                    id="statut"
                    class="form-control col-8"
                    v-model="statut"
                    name="statut"
                  >
                    <option value="">Sélectionner...</option>
                    <option
                      v-for="s in DEMAND_STATUS"
                      :value="s.value"
                      :key="s.id"
                    >
                      {{ s.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <div class="form-row">
                  <label for="lastname" class="col-4 text-right">Nom:</label>
                  <input
                    type="text"
                    v-model="lastname"
                    name="lastname"
                    id="lastname"
                    class="form-control col-8"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-row">
                  <label for="firstname" class="col-4 text-right"
                    >Prénom:</label
                  >
                  <input
                    type="text"
                    v-model="firstname"
                    name="firstname"
                    id="firstname"
                    class="form-control col-8"
                  />
                </div>
              </div>
            </div>

            <p class="text-primary" v-if="!more_criteria">
              <!-- <a @click.prevent="handleCriteria" href=""> Plus de critères >></a> -->
              <button
                class="btn btn-outline-primary btn-sm"
                title="Plus de critères"
                type="button"
                @click="handleCriteria"
              >
                Plus de critères
                <i class="fas fa-arrow-down"></i>
              </button>
            </p>

            <div class="row mb-2" v-if="more_criteria">
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">
                  Filtrage par date d'arrivée des demandeurs
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="arrival_start_date" class="col-4 text-right"
                        >Début:</label
                      >
                      <VueCtkDateTimePicker
                        name="arrival_start_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="arrival_start_date"
                        label="date début"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="arrival_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="arrival_end_date" class="col-4 text-right"
                        >Fin:</label
                      >
                      <VueCtkDateTimePicker
                        name="arrival_end_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="arrival_end_date"
                        label="date fin"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="arrival_end_date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">
                  Filtrage par pays de passeport et type e-Visa
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="passport_country" class="col-4 text-right"
                        >Pays Passeport:</label
                      >
                      <v-select
                        multiple
                        id="passport_country"
                        class="col-8"
                        v-model="passport_country"
                        :options="countries"
                        label="name"
                        name="passport_country"
                        :reduce="(country) => country.id"
                        style="padding: 0"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="visatype" class="col-4 text-right"
                        >Type de visa:</label
                      >
                      <select
                        id="visatype"
                        name="visatype"
                        class="form-control col-8"
                        v-model="visatype"
                      >
                        <option disabled value="">...</option>
                        <option
                          v-for="v in visatypes"
                          :value="v.id"
                          :key="v.id"
                        >
                          {{
                            v.name
                              ? `${v.name}-Evisa-${v.duration} jours-${
                                  v.entry_mode === "SINGLE"
                                    ? "Entrée simple"
                                    : "Entrée multiple"
                                }`
                              : `Evisa-${v.duration} jours-${
                                  v.entry_mode === "SINGLE"
                                    ? "Entrée simple"
                                    : "Entrée multiple"
                                }`
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-2" v-if="more_criteria">
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">
                  Filtrage par date de départ des demandeurs
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="departure_start_date" class="col-4 text-right"
                        >Début:</label
                      >
                      <VueCtkDateTimePicker
                        name="departure_start_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="departure_start_date"
                        label="date début"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="departure_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="departure_end_date" class="col-4 text-right"
                        >Fin:</label
                      >
                      <VueCtkDateTimePicker
                        name="departure_end_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="departure_end_date"
                        label="date fin"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="departure_end_date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">
                  Filtrage par nationalité et pays de naissance
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="nationality" class="col-4 text-right"
                        >Nationalité:</label
                      >
                      <v-select
                        multiple
                        id="nationality"
                        name="nationality"
                        class="col-8"
                        v-model="nationality"
                        :options="countries"
                        label="name"
                        :reduce="(country) => country.id"
                        style="padding: 0"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="birth_country" class="col-4 text-right"
                        >Pays Naissance:</label
                      >
                      <v-select
                        multiple
                        id="birth_country"
                        name="birth_country"
                        class="col-8"
                        v-model="birth_country"
                        :options="countries"
                        label="name"
                        :reduce="(country) => country.id"
                        style="padding: 0"
                      >
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-2" v-if="more_criteria">
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">
                  Filtrage par date de naissance des demandeurs
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="birth_start_date" class="col-4 text-right"
                        >Début:</label
                      >
                      <VueCtkDateTimePicker
                        name="birth_start_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="birth_start_date"
                        label="date début"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="birth_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="birth_end_date" class="col-4 text-right"
                        >Fin:</label
                      >
                      <VueCtkDateTimePicker
                        name="birth_end_date"
                        class="ml-0 mr-0 pl-0 pr-0 col-8"
                        v-model="birth_end_date"
                        label="date fin"
                        color="#0a3764"
                        button-color="#0a3764"
                        locale="fr"
                        input-size="sm"
                        format="YYYY-MM-DD HH:mm"
                        button-now-translation="Aujourd'hui"
                        id="birth_end_date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="mb-2" v-if="more_criteria">Genre et office</p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="gender" class="col-4 text-right"
                        >Genre:</label
                      >
                      <select
                        id="gender"
                        name="gender"
                        class="form-control col-8"
                        v-model="gender"
                      >
                        <option disabled value="">...</option>
                        <option
                          v-for="v in genders"
                          :value="v.value"
                          :key="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row">
                      <label for="from_office" class="col-4 text-right"
                        >Ambassade:</label
                      >
                      <select
                        id="from_office"
                        name="from_office"
                        class="form-control col-8"
                        v-model="from_office"
                      >
                        <option disabled value="">...</option>
                        <option
                          v-for="v in from_offices"
                          :value="v.value"
                          :key="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p class="text-primary" v-if="more_criteria">
              <br />
              <!-- <label @click="handleCriteria"> &#60;&#60; Moins de critères</label> -->
              <!-- <a @click.prevent="handleCriteria" href="">
            &#60;&#60; Moins de critères</a
          > -->
              <button
                class="btn btn-outline-primary btn-sm"
                title="Moins de critères"
                type="button"
                @click="handleCriteria"
              >
                Moins de critères
                <i class="fas fa-arrow-up"></i>
              </button>
            </p>

            <!-- <br /> -->
            <hr />

            <div class="row">
              <!-- <label class="col-md-1"></label> -->
              <div class="col-md-12">
                <button
                  type="submit"
                  class="btn btn-primary mr-2 btn-lg"
                  title="Lancer la recherche"
                >
                  Rechercher
                </button>
                <button
                  class="btn btn-outline-primary btn-lg"
                  title="Effacer le filtre"
                  type="button"
                  @click="resetFilter"
                >
                  Effacer le filtre
                </button>
              </div>
            </div>
          </div>
        </transition>
      </form>
    </nav>
    <!-- Affichage d'erreur -->
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': error,
        }"
        role="alert"
        v-show="error"
      >
        {{ this.error }}
      </div>
    </div>
    <div
      class="alert text-left formatted-text"
      :class="{
        'alert-danger': message.error,
        'alert-success': !message.error,
      }"
      role="alert"
      v-show="message.display"
    >
      {{ this.message.content }}
    </div>

    <!-- <p
      class="text-right"
      v-if="
        !(
          (Object.keys(demandsr).length === 0 &&
            demandsr.constructor === Object) ||
          demandsr.data.length === 0
        )
      "
    >
      <button
        class="d-none d-sm-inline-block btn btn-sm btn-outline-danger shadow-sm"
        v-if="
          !(
            (Object.keys(demandsr).length === 0 &&
              demandsr.constructor === Object) ||
            demandsr.data.length === 0
          )
        "
        @click="generateReport"
      >
        <i class="far fa-file-pdf"></i>
        Imprimer le Rapport
      </button> -->
    <!-- <button @click="generateReport" class="btn btn-outline-info">Imprimer</button> -->
    <!-- </p> -->

    <div
      class="table-responsive"
      v-if="userPermissions.some((e) => [P_REPORT_MASTER].includes(e))"
    >
      <nav
        v-if="
          !(
            (Object.keys(demandsr).length === 0 &&
              demandsr.constructor === Object) ||
            demandsr.data.length === 0
          )
        "
        aria-label="Report list search pagination top"
      >
        <div class="row">
          <div class="col-md-6">
            <ul class="pagination">
              <li
                v-for="(v, index) in demandsr.meta.links"
                :key="index"
                class="page-item"
                :class="{ active: v.active, disabled: v.url === null }"
                :aria-current="{ page: v.active }"
                @click="filterBy(getNextPageIndex(v.url))"
              >
                <router-link class="page-link" to="">
                  {{
                    index === 0
                      ? "&laquo; Précédent"
                      : index === demandsr.meta.links.length - 1
                      ? "Suivant &raquo;"
                      : v.label
                  }}
                  <span v-if="v.active" class="sr-only">(current)</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <p
              class="text-right"
              v-if="
                !(
                  (Object.keys(demandsr).length === 0 &&
                    demandsr.constructor === Object) ||
                  demandsr.data.length === 0
                )
              "
            >
              <button
                class="d-none d-sm-inline-block btn btn-sm btn-outline-danger shadow-sm"
                v-if="
                  !(
                    (Object.keys(demandsr).length === 0 &&
                      demandsr.constructor === Object) ||
                    demandsr.data.length === 0
                  )
                "
                @click="generateReportBiss"
              >
                <i class="far fa-file-pdf"></i>
                Imprimer le Rapport
              </button>
            </p>
          </div>
        </div>
      </nav>

      <!-- <table
        v-if="
          !(
            (Object.keys(demandsr).length === 0 &&
              demandsr.constructor === Object) ||
            demandsr.data.length === 0
          )
        "
        id="dataTable"
        class="table table-bordered table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Référence</th>
            <th>Document</th>
            <th>Type document</th>
            <th>Type eVisa</th>
            <th>Statut</th>
            <th>Recherché</th>
            <th>Date demande</th>
          </tr>
        </thead>
        <tbody>
          <DemandItem
            v-for="demand in demandsr.data"
            :demand="demand"
            :key="demand.id"
          />
        </tbody>
      </table> -->
      <div
        v-if="
          !(
            (Object.keys(demandsr).length === 0 &&
              demandsr.constructor === Object) ||
            demandsr.data.length === 0
          )
        "
        style="background-color: white"
      >
        <div id="html2pdf-report">
          <div style="color: black" class="mr-2">
            <!-- header -->
            <div>
              <div style="display: inline-block; width: 100%">
                <div style="float: left">
                  <img
                    src="@/assets/logo-evisa-blue.png"
                    style="height: 90px; width: auto; max-width: 300px"
                  />
                </div>
                <div style="float: right">
                  <img
                    src="@/assets/logo_dei.png"
                    style="height: 90; width: auto; max-width: 300px"
                  />
                </div>
              </div>
              <br />
              <br />
              <br />
              <div class="row">
                <div class="col-md-5">
                  <h5 class="text-left">
                    Nombre total:

                    {{ demandsr.data.length }}
                  </h5>
                </div>
                <div
                  class="col-md-7"
                  v-if="demand_start_date && demand_end_date"
                >
                  <h5 class="text-right">
                    <!-- Rapport imprimé ce {{ new Date() | format_date }} -->
                    Rapport du
                    {{ format_date(demand_start_date) }}
                    au
                    {{ format_date(demand_end_date) }}
                  </h5>
                </div>
              </div>
            </div>

            <br />

              <table class="divTable1" style="width: 100%;">
                <thead>
                  <tr class="headRow1">
                    <th class="divCell1 text-center">Nom</th>
                    <th class="divCell2">Prénom</th>
                    <th class="divCell3">Référence</th>
                    <th class="divCell4">Document</th>
                    <th class="divCell5">Type visa</th>
                    <th class="divCell6">Statut</th>
                    <th class="divCell7">Recherché</th>
                    <th class="divCell8">Date demande</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="divRow1"
                    v-for="(demand, index) in demandsr.data"
                    :key="demand.id"
                    :class="{
                      'html2pdf__page-break': index == 7,
                      'html2pdf__page-break': 0 == (index - 7) % 13,
                    }"
                  >
                    <td class="divCell1">{{ demand.lastname }}</td>
                    <td class="divCell2">{{ demand.firstname }}</td>
                    <td class="divCell3">{{ demand.reference }}</td>
                    <td class="divCell4">{{ demand.document_number }}</td>
                    <td class="divCell5">{{ demand.visatype_name }}</td>
                    <td class="divCell6">
                      <span
                        :class="{
                          'badge badge-success': demand.state === 'GENERATED',
                          'badge badge-warning': [
                            'VALIDATION',
                            'PROCESSING',
                          ].includes(demand.state),
                          'badge badge-danger': demand.state === 'REJECTED',
                        }"
                      >
                        {{ DEMAND_STATUS_TRANSLATION[demand.state] }}
                      </span>
                    </td>
                    <td class="divCell7">
                      <span
                        :class="{
                          'badge badge-success': !demand.matched,
                          'badge badge-danger': demand.matched,
                        }"
                      >
                        {{ demand.matched ? demand.matched : "Non" }}
                      </span>
                    </td>
                    <td class="divCell8">
                      {{
                        demand.demand_date
                          | dateParse("YYYY-MM-DD HH:mm:ss")
                          | dateFormat("DD/MM/YYYY HH:mm:ss")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

            <!-- footer -->
            <div></div>
          </div>
        </div>
      </div>
      <div v-else>
        <p style="text-align: center">
          <br />
          Aucunes données
        </p>
      </div>

      <br />

      <nav
        v-if="
          !(
            (Object.keys(demandsr).length === 0 &&
              demandsr.constructor === Object) ||
            demandsr.data.length === 0
          )
        "
        aria-label="Report list search pagination bottom"
      >
        <ul class="pagination">
          <li
            v-for="(v, index) in demandsr.meta.links"
            :key="index + 'a'"
            class="page-item"
            :class="{ active: v.active, disabled: v.url === null }"
            :aria-current="{ page: v.active }"
            @click="filterBy(getNextPageIndex(v.url))"
          >
            <router-link class="page-link" to="">
              {{
                index === 0
                  ? "&laquo; Précédent"
                  : index === demandsr.meta.links.length - 1
                  ? "Suivant &raquo;"
                  : v.label
              }}
              <span v-if="v.active" class="sr-only">(current)</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        filename="rapport"
        :pdf-quality="2"
        pdf-content-width="100%"
        :manual-pagination="true"
        :paginate-elements-by-height="1400"
        pdf-format="a4"
        pdf-orientation="landscape"
        ref="html2Pdf"
        name="generateP"
        :html-to-pdf-options="pdf_options"
      >
        <!-- @progress="onProgress($event)"
              @hasStartedGeneration="hasStartedGeneration()"
              @hasGenerated="hasGenerated($event)" -->
        <section slot="pdf-content">
          <div style="color: black" class="mr-2">
            <!-- header -->
            <div>
              <div style="display: inline-block; width: 100%">
                <div style="float: left">
                  <img
                    src="@/assets/logo-evisa-blue.png"
                    style="height: 90px; width: auto; max-width: 300px"
                  />
                </div>
                <!-- <hr /> -->
                <!-- <div style="display: inline">
                <h2
                  class="text-center text-white bg-danger"
                  style="display: inline"
                >
                  Rapport demande
                </h2>
              </div> -->
                <div style="float: right">
                  <img
                    src="@/assets/logo_dei.png"
                    style="height: 90; width: auto; max-width: 300px"
                  />
                </div>
              </div>
              <br />
              <br />
              <div v-if="demand_start_date && demand_end_date">
                <h4 class="text-center">
                  <!-- Rapport imprimé ce {{ new Date() | format_date }} -->
                  Rapport du
                  {{ format_date(demand_start_date) }}
                  au
                  {{ format_date(demand_end_date) }}
                </h4>
              </div>
            </div>

            <br />
            <br />

            <!-- content -->

            <!-- <div class="divTable1">
              <div class="headRow1">
                <div class="divCell1 text-center">Nom</div>
                <div class="divCell2">Prénom</div>
                <div class="divCell3">Référence</div>
                <div class="divCell4">Document</div>
                <div class="divCell5">Type visa</div>
                <div class="divCell6">Statut</div>
                <div class="divCell7">Recherché</div>
                <div class="divCell8">Date demande</div>
              </div>
              <div
                class="divRow1"
                v-for="(demand, index) in demandsr.data"
                :key="demand.id"
                :class="{
                  'html2pdf__page-break': index == 7,
                  'html2pdf__page-break': 0 == (index - 7) % 13,
                }"
              >
                <div class="divCell1">{{ demand.lastname }}</div>
                <div class="divCell2">{{ demand.firstname }}</div>
                <div class="divCell3">{{ demand.reference }}</div>
                <div class="divCell4">{{ demand.document_number }}</div>
                <div class="divCell5">{{ demand.visatype_name }}</div>
                <div class="divCell6">
                  <span
                    :class="{
                      'badge badge-success': demand.state === 'GENERATED',
                      'badge badge-warning': [
                        'VALIDATION',
                        'PROCESSING',
                      ].includes(demand.state),
                    }"
                  >
                    {{ demand.state }}
                  </span>
                </div>
                <div class="divCell7">
                  <span
                    :class="{
                      'badge badge-success': !demand.matched,
                      'badge badge-danger': demand.matched,
                    }"
                  >
                    {{ demand.matched ? demand.matched : "Non" }}
                  </span>
                </div>
                <div class="divCell8">
                  {{
                    demand.demand_date
                      | dateParse("YYYY-MM-DD HH:mm:ss")
                      | dateFormat("DD/MM/YYYY HH:mm:ss")
                  }}
                </div>
              </div>
            </div> -->

            <table class="divTable1">
              <thead>
                <tr class="headRow1">
                  <th class="divCell1 text-center">Nom</th>
                  <th class="divCell2">Prénom</th>
                  <th class="divCell3">Référence</th>
                  <th class="divCell4">Document</th>
                  <th class="divCell5">Type visa</th>
                  <th class="divCell6">Statut</th>
                  <th class="divCell7">Recherché</th>
                  <th class="divCell8">Date demande</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="divRow1"
                  v-for="(demand, index) in demandsr.data"
                  :key="demand.id"
                  :class="{
                    'html2pdf__page-break': index == 7,
                    'html2pdf__page-break': 0 == (index - 7) % 13,
                  }"
                >
                  <td class="divCell1">{{ demand.lastname }}</td>
                  <td class="divCell2">{{ demand.firstname }}</td>
                  <td class="divCell3">{{ demand.reference }}</td>
                  <td class="divCell4">{{ demand.document_number }}</td>
                  <td class="divCell5">{{ demand.visatype_name }}</td>
                  <td class="divCell6">
                    <span
                      :class="{
                        'badge badge-success': demand.state === 'GENERATED',
                        'badge badge-warning': [
                          'VALIDATION',
                          'PROCESSING',
                        ].includes(demand.state),
                      }"
                    >
                      {{ DEMAND_STATUS_TRANSLATION[demand.state] }}
                    </span>
                  </td>
                  <td class="divCell7">
                    <span
                      :class="{
                        'badge badge-success': !demand.matched,
                        'badge badge-danger': demand.matched,
                      }"
                    >
                      {{ demand.matched ? demand.matched : "Non" }}
                    </span>
                  </td>
                  <td class="divCell8">
                    {{
                      demand.demand_date
                        | dateParse("YYYY-MM-DD HH:mm:ss")
                        | dateFormat("DD/MM/YYYY HH:mm:ss")
                    }}
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- <hr />
            <div>
              <span class="mr-2"> Nom</span>
              <span class="mr-2"> Prénom </span>
              <span class="mr-2"> Identifiant </span>
              <span class="mr-2"> Document </span>
              <span class="mr-2">Type</span>
              <span class="mr-2">Type visa</span>
              <span> Statut</span>
              <span class="mr-2"> Recherché </span>
              <span class="mr-2">Date demande</span>
            </div>
            <hr /> -->

            <!-- <div v-for="demand in demandsr" :key="demand.id">
              <div>
                <span class="mr-2">{{ demand.lastname }}</span>
                <span class="mr-2">{{ demand.firstname }}</span>
                <span class="mr-2">{{ demand.reference }}</span>
                <span class="mr-2">{{ demand.document_number }}</span>
                <span class="mr-2">{{
                  demand.document_type | capitalize
                }}</span>
                <span class="mr-2">{{ demand.visatype_name }}</span>
                <span
                  class="mr-2"
                  :class="{
                    'badge badge-success': demand.state === 'GENERATED',
                    'badge badge-warning': [
                      'VALIDATION',
                      'PROCESSING',
                    ].includes(demand.state),
                  }"
                >
                  {{ demand.state }}</span
                >
                <span
                  class="mr-2"
                  :class="{
                    'badge badge-success': !demand.matched,
                    'badge badge-danger': demand.matched,
                  }"
                >
                  {{ demand.matched ? demand.matched : "Non" }}
                </span>
                <span class="mr-2">{{
                  demand.demand_date
                    | dateParse("YYYY-MM-DD HH:mm:ss")
                    | dateFormat("DD/MM/YYYY HH:mm:ss")
                }}</span>
              </div>
              <hr />
            </div> -->

            <!-- footer -->
            <div></div>
          </div>
        </section>
      </vue-html2pdf>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
import { mapGetters } from "vuex";

import vSelect from "vue-select";
// import * as $ from "jquery"; // for datatable
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";

import { P_REPORT_MASTER } from "@/helpers/permissions";
import { SET_LOADING } from "@/store/mutations.type";
import {
  FETCH_DEMANDS_REPORT,
  FETCH_COUNTRIES,
  FETCH_VISATYPES,
} from "@/store/actions.type";
// import DemandItem from "./DemandItem";
// import frLocalDatatable from "@/assets/french.json";
import { DEMAND_STATUS, DEMAND_STATUS_TRANSLATION, SUCCESS_MESSAGE } from "@/helpers/messages";
import { DEMAND_REPORT } from '../../store/actions.type';

export default {
  components: {
    // DemandItem,
    VueHtml2pdf,
    vSelect,
  },
  data() {
    return {
      error: "",
      demand_start_date: "",
      demand_end_date: "",
      arrival_start_date: "",
      arrival_end_date: "",
      departure_start_date: "",
      departure_end_date: "",
      birth_start_date: "",
      birth_end_date: "",
      nationality: "",
      birth_country: "",
      passport_country: "",
      visatype: "",
      statut: "",
      gender: "",
      from_office: "",
      lastname: "",
      firstname: "",
      submitted: false,
      genders: [
        { id: 1, value: "male", label: "Masculin" },
        { id: 2, value: "female", label: "Féminin" },
        { id: 3, value: "other", label: "Autre" },
      ],
      from_offices: [
        { id: 1, value: 1, label: "Oui" },
        { id: 2, value: 0, label: "Non" },
      ],
      P_REPORT_MASTER,
      more_criteria: false,
      display_pannel: true,
      pdf_options: {
        margin: 0.2,
        filename: "rapport.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      },
      DEMAND_STATUS,
      DEMAND_STATUS_TRANSLATION,
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },
  async mounted() {
    await this.getVisatypes();
    await this.getCountries();
  },
  computed: {
    ...mapGetters(["demandsr", "userPermissions", "visatypes", "countries"]),
  },
  methods: {
    filterBy(page = 1) {
      this.submitted = true;

      if (page === null || !this.demand_start_date || !this.demand_end_date) {
        return;
      }

      if (typeof page != "number") {
        page = 1;
      }

      this.$store.commit(SET_LOADING, true);

      let params = {};
      params.page = page;
      if (this.demand_start_date) params.startdate = this.demand_start_date;
      if (this.demand_end_date) params.enddate = this.demand_end_date;
      if (this.arrival_start_date)
        params.startdate_arrival = this.arrival_start_date;
      if (this.arrival_end_date) params.enddate_arrival = this.arrival_end_date;
      if (this.departure_start_date)
        params.startdate_departure = this.departure_start_date;
      if (this.departure_end_date)
        params.enddate_departure = this.departure_end_date;
      if (this.birth_start_date)
        params.startdate_birthday = this.birth_start_date;
      if (this.birth_end_date) params.enddate_birthday = this.birth_end_date;
      if (this.gender) params.gender = this.gender;
      if (this.visatype) params.visatype = this.visatype;
      if (this.from_office) params.priority = this.from_office;

      if (this.nationality) {
        this.nationality.map((v) => {
          if (params.nationality) {
            params.nationality = `${params.nationality},${v}`;
          } else {
            params.nationality = v;
          }
        });
      }

      if (this.birth_country) {
        this.birth_country.map((v) => {
          if (params.birth_country) {
            params.birth_country = `${params.birth_country},${v}`;
          } else {
            params.birth_country = v;
          }
        });
      }

      if (this.passport_country) {
        this.passport_country.map((v) => {
          if (params.passport_country) {
            params.passport_country = `${params.passport_country},${v}`;
          } else {
            params.passport_country = v;
          }
        });
      }

      if (this.lastname) params.lastname = this.lastname;
      if (this.firstname) params.firstname = this.firstname;

      if (this.statut == "VALIDATED") {
        (params.state = "GENERATED"),
          (params.matched = "REDLIST,INTERPOL,GEN_AUTO");
      } else if (this.statut != "VALIDATED" && this.statut) {
        params.state = this.statut;
      } else {
        params.state = "GENERATED,PROCESSING,VALIDATION";
      }

      console.log(params);

      // On détruit le dataTable
      //this.destroyDatatable();

      this.$store
        .dispatch(FETCH_DEMANDS_REPORT, params)
        .then(() => {
          // On réaffiche le dataTable
          // this.renderDatatable();
        })
        .catch(() => {
          // this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
          // datatable
          // $(document).ready(function () {
          //   $("#dataTable").DataTable({
          //     language: frLocalDatatable,
          //   });
          // });
          this.submitted = false;
        });
    },
    getNextPageIndex(url) {
      if (url === null) {
        return null;
      }

      return parseInt(url.split("?")[1].split("=")[1]);
    },
    resetFilter() {
      this.demand_start_date = "";
      this.demand_end_date = "";
      this.arrival_start_date = "";
      this.arrival_end_date = "";
      this.departure_start_date = "";
      this.departure_end_date = "";
      this.birth_start_date = "";
      this.birth_end_date = "";
      this.nationality = "";
      this.birth_country = "";
      this.passport_country = "";
      this.visatype = "";
      this.statut = "";
      this.gender = "";
      this.from_office = "";
    },

    // destroyDatatable() {
    //   let dt = $("#dataTable").DataTable();
    //   if (dt) {
    //     dt.destroy();
    //   }
    // },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    generateReportBis() {
      let element = document.getElementById("html2pdf-report");
      let pdf_options = {
        margin: 0.2,
        filename: "rapport.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      html2pdf()
        .set(pdf_options)
        .from(element)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          let totalPages = pdf.internal.getNumberOfPages();
          let d = new Date();

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              `Rapport imprimé ce ${d.getDate()}/${
                d.getMonth() + 1
              }/${d.getFullYear()}  |  ${i}`,
              pdf.internal.pageSize.getWidth() - 3,
              pdf.internal.pageSize.getHeight() - 0.3
            );
            // pdf.text('' + i, (pdf.internal.pageSize.getWidth()/2), (pdf.internal.pageSize.getHeight() - 0.3));
          }
        })
        .save();

      // html2pdf().set(pdf_options).from(element).save();
    },
    generateReportBiss(){

      let params = {};
      params.report = "1";
      if (this.demand_start_date) params.startdate = this.demand_start_date;
      if (this.demand_end_date) params.enddate = this.demand_end_date;
      if (this.arrival_start_date)
        params.startdate_arrival = this.arrival_start_date;
      if (this.arrival_end_date) params.enddate_arrival = this.arrival_end_date;
      if (this.departure_start_date)
        params.startdate_departure = this.departure_start_date;
      if (this.departure_end_date)
        params.enddate_departure = this.departure_end_date;
      if (this.birth_start_date)
        params.startdate_birthday = this.birth_start_date;
      if (this.birth_end_date) params.enddate_birthday = this.birth_end_date;
      if (this.gender) params.gender = this.gender;
      if (this.visatype) params.visatype = this.visatype;
      if (this.from_office) params.priority = this.from_office;

      if (this.nationality) {
        this.nationality.map((v) => {
          if (params.nationality) {
            params.nationality = `${params.nationality},${v}`;
          } else {
            params.nationality = v;
          }
        });
      }

      if (this.birth_country) {
        this.birth_country.map((v) => {
          if (params.birth_country) {
            params.birth_country = `${params.birth_country},${v}`;
          } else {
            params.birth_country = v;
          }
        });
      }

      if (this.passport_country) {
        this.passport_country.map((v) => {
          if (params.passport_country) {
            params.passport_country = `${params.passport_country},${v}`;
          } else {
            params.passport_country = v;
          }
        });
      }

      if (this.lastname) params.lastname = this.lastname;
      if (this.firstname) params.firstname = this.firstname;

      if (this.statut == "VALIDATED") {
        (params.state = "GENERATED"),
          (params.matched = "REDLIST,INTERPOL,GEN_AUTO");
      } else if (this.statut != "VALIDATED" && this.statut) {
        params.state = this.statut;
      } else {
        params.state = "GENERATED,PROCESSING,VALIDATION";
      }

      
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(DEMAND_REPORT, params)
        .then((response) => {
          console.log(response);
          this.$store.commit(SET_LOADING, false);
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "report.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(SET_LOADING, false);
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
        });

    },
    handleCriteria() {
      this.more_criteria = !this.more_criteria;
    },
    handleDisplayPannel() {
      this.display_pannel = !this.display_pannel;
    },
    getVisatypes() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_VISATYPES)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    getCountries() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_COUNTRIES)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    format_date(dateObj) {
      let par = dateObj.split(" ");
      let pn = par[0].split("-");

      return pn[2] + "/" + pn[1] + "/" + pn[0] + " " + par[1];
    },
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>

<style lang="scss" scoped>
.vs__dropdown-toggle {
  height: 38px;
}

.divTable1 {
  // display: table;
  // width: 100%;
}

.divRow1,
.headRow1 {
  // display: table-row;
  // width: 100%;
  // border: 1px solid #666666;
}

.divCell1,
.divCell2,
.divCell3,
.divCell4,
.divCell5,
.divCell6,
.divCell7,
.divCell8 {
  // float: left; /*fix for  buggy browsers*/
  // display: table-column;
  //width: 10%;
  // padding-left: 2px;
  // height: auto;
  // line-height: 50px;
  text-align: center;
  border: 1px solid #666666;
}

.divCell5 {
  // line-height: unset;
}

.divCell3 {
 // width: 15%;
}
.divCell5 {
 // width: 17%;
}

.divCell8 {
 // width: 15%;
  // border-right: none;
}
.form-row {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
nav .row,
nav div[class^="col"],
.form-row {
  margin-left: unset !important;
  margin-right: unset !important;
  padding-left: unset !important;
  padding-right: unset !important;
}

/* transition */
/* Les animations d'entrée (« enter ») et de sortie (« leave »)  */
/* peuvent utiliser différentes fonctions de durée et de temps.  */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>